export enum SiteContextType {
  LANGUAGE = 'LANGUAGE',
  CURRENCY = 'CURRENCY',
}
